import React from 'react'
import styles from './lottieSection.module.css'
import Lottie from 'react-lottie'
import { lottieOptions } from '../../../utils'
import Success from '../laptopScreen.json'
import laptopScreen from '../../../public/assets/laptopScreen.png'

function ThirdSection() {
  return (
    <div  className={styles.secondsectionRow}>
        <p className={styles.secondSectionHeading}>Fully online process with</p>
        <p style={{color: "#0061D3"}} className={styles.secondSectionHeading}> Live Tracking </p>
        <p className={styles.secondSectionContent}>Experience a hassle-free, fully digital remittance process with live tracking for real-time updates from start to finish. No offline paperwork, no delays — just seamless transfers. We even securely save your documents so you don't need to ever upload the same documents again.
        </p>
        <div className={styles.lottiemobile2} style={{position: "relative"}}>
        <img src={laptopScreen} alt="laptopScreen" className={styles.laptopScreen}></img>
            <Lottie
              options={lottieOptions(Success)}
              style={{ position: "absolute", top: "18%", width: "55%", height: "55%", left: "22%" }}
            />
            </div>
    </div>
  )
}

export default ThirdSection